<template>
  <v-card>
    <v-card-title class="py-0" style="height: 64px">
      <span class="title">手动发送</span>
      <v-btn color="primary" flat @click="addReceiver()">添加发送人</v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="max-height: 500px">
      <v-container class="pt-0" fluid grid-list-md>
        <v-form ref="sendForm">
          <v-layout column>
            <v-radio-group mandatory row v-model="templateInfo.isDate" label="发送方式" prepend-icon="$vuetify.icons.lock">
              <v-radio :value="false" label="即时发送"></v-radio>
              <v-radio :value="true" label="定时发送"></v-radio>
            </v-radio-group>
            <l-select-datetime v-model="templateInfo.date" label="发送时间" v-if="templateInfo.isDate" :rules=[$rules.requiredS()]></l-select-datetime>
          </v-layout>
          <v-layout column v-for="(r,i) in receiverList" :key="i">
            <v-divider></v-divider>
            <v-flex xs12>
              <v-text-field label="接收地址" prepend-icon="$vuetify.icons.location" v-model="r.address" :rules="[$rules.requiredS()]"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea v-model="r.content" rows="1" auto-grow label="发送预览" prepend-icon="$vuetify.icons.comment" :rules="[$rules.requiredS()]">
              </v-textarea>
            </v-flex>
            <v-layout v-for="(l,i) in r.labelList" :ke="i">
              <v-flex xs4>
                <v-text-field label="标签名称" prepend-icon="$vuetify.icons.title" v-model="l.name" :rules="[$rules.requiredS()]"></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field label="标签配置" prepend-icon="$vuetify.icons.code" v-model="l.value" :rules="[$rules.requiredS()]"></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="sendMessage" :loading="loading">发送</v-btn>
      <v-btn large color="grey" flat @click="cancel()">取消</v-btn>
      <!--<v-btn :loading="actionLoading" large color="primary" flat @click="send()">发送</v-btn>-->
    </v-card-actions>
  </v-card>
</template>

<script>
import LSelectDatetime from '../../../ladmin/components/LSelectDatetime/LSelectDatetime'
let variablePattern = /({[^{}]+})/g
export default {
  name: 'sendMessageContent',
  components: {LSelectDatetime},
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      templateInfo: {
        content: '',
        type: '',
        labelList: [],
        institutionId: '',
        isDate: false,
        date: '',
        tmpltId: ''
      },
      receiverList: []
    }
  },
  created () {
    console.log(this.item)
    this.init()
  },
  methods: {
    init () {
      this.templateInfo.content = this.item.tmpltContent
      this.templateInfo.type = this.item.type
      this.templateInfo.institutionId = this.item.institutionId
      this.templateInfo.tmpltId = this.item.id
      for (let i = 0; i < this.item.tmpltBizs.length; i++) {
        let l = {
          name: this.item.tmpltBizs[i].msgLabelBiz.name,
        }
        this.templateInfo.labelList.push(l)
      }
      for (let i = 0; i < this.item.tmpltSyss.length; i++) {
        let label = '{' + this.item.tmpltSyss[i].msgLabelSys.name + '}'
        let newStr = this.templateInfo.content.replace(label, this.item.tmpltSyss[i].msgLabelSys.value)
        this.templateInfo.content = newStr
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    addReceiver () {
      let r = {
        content: this.templateInfo.content,
        labelList: [],
        address: ''
      }
      for (let i = 0; i < this.templateInfo.labelList.length; i++) {
        let l = {
          name: this.templateInfo.labelList[i].name,
          value: '',
        }
        r.labelList.push(l)
      }
      this.receiverList.push(r)
    },
    async sendMessage () {
      if (this.$refs.sendForm.validate()) {
        let labelsList = []
        let addressList = []
        for (let i = 0; i < this.receiverList.length; i++) {
          let r = this.receiverList[i]
          let labelList = []
          addressList.push(r.address)
          for (let j = 0; j < r.labelList.length; j++) {
            labelList.push(r.labelList[j].value)
          }
          labelsList.push(labelList)
        }
        let params
        if (this.templateInfo.isDate) {
          params = {
            'tmpltId': this.templateInfo.tmpltId,
            'labelsList': labelsList,
            'addressList': addressList,
            'institutionId': this.templateInfo.institutionId,
            'date': (this.templateInfo.isDate) ? this.$L.time.toTimeStamp(this.templateInfo.date) : null
          }
        }
        else {
          params = {
            'tmpltId': this.templateInfo.tmpltId,
            'labelsList': labelsList,
            'addressList': addressList,
            'institutionId': this.templateInfo.institutionId,
          }
        }
        this.loading = true
        try {
          let res = await this.$store.dispatch('message/sendMsgByTemplate', params)
          console.log(res)
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据错误'})
      }
    }
  },
  watch: {
    'receiverList': {
      handler (val) {
        for (let i = 0; i < this.receiverList.length; i++) {
          let r = this.receiverList[i]
          let t = this.templateInfo.content
          let names = t.match(variablePattern) || []
          let contents = []
          for (let j = 0; j < names.length; j++) {
            for (let k = 0; k < r.labelList.length; k++) {
              if (names[j] === '{' + r.labelList[k].name + '}') {
                contents.push(r.labelList[k].value)
                break
              }
            }
          }
          // console.log(names)
          let newText = ''
          for (let i = 0; i < names.length; ++i) {
            let idx = t.indexOf(names[i])
            let content = (contents[i] === '') ? names[i] : contents[i]
            newText += t.slice(0, idx + names[i].length).replace(names[i], content)
            // console.log(`replace ${idx + names[i].length}`, t.slice(0, idx + names[i].length), names[i], content)
            t = t.slice(idx + names[i].length)
          }
          newText += t
          r.content = newText
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
